// File: src/globalComponents/NavigationCache.js

// Profile cache constants
const PROFILE_CACHE_KEY_PREFIX = 'profile_cache_';
const PROFILE_CACHE_EXPIRY  = 3 * 60 * 60 * 1000; // 3 hours in milliseconds

// Nav state cache constants
const NAV_STATE_CACHE_KEY_PREFIX = 'nav_state_cache_';
const NAV_STATE_CACHE_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours

// ========== PROFILE CACHE ==========
export const ProfileCache = {
  // Save profile data to cache
  set: (consoleType, profileData) => {
    try {
      const cacheKey = `${PROFILE_CACHE_KEY_PREFIX}${consoleType}`;
      const cacheData = {
        data: profileData,
        timestamp: Date.now()
      };
      localStorage.setItem(cacheKey, JSON.stringify(cacheData));
    } catch (error) {
      console.error('Error saving profile to cache:', error);
    }
  },

  // Get profile data from cache
  get: (consoleType) => {
    try {
      const cacheKey = `${PROFILE_CACHE_KEY_PREFIX}${consoleType}`;
      const cached = localStorage.getItem(cacheKey);
      
      if (!cached) return null;
      
      const cacheData = JSON.parse(cached);
      const now = Date.now();
      
      // Check if cache is expired
      if (now - cacheData.timestamp > PROFILE_CACHE_EXPIRY) {
        // Cache expired, remove it
        localStorage.removeItem(cacheKey);
        return null;
      }
      
      return cacheData.data;
    } catch (error) {
      console.error('Error reading profile from cache:', error);
      return null;
    }
  },

  // Clear profile cache for specific console
  clear: (consoleType) => {
    try {
      const cacheKey = `${PROFILE_CACHE_KEY_PREFIX}${consoleType}`;
      localStorage.removeItem(cacheKey);
    } catch (error) {
      console.error('Error clearing profile cache:', error);
    }
  },

  // Clear all profile caches
  clearAll: () => {
    try {
      ['admin-console', 'iam-console'].forEach(consoleType => {
        ProfileCache.clear(consoleType);
      });
    } catch (error) {
      console.error('Error clearing all profile caches:', error);
    }
  }
};

// ========== NAV STATE CACHE ==========
export const NavStateCache = {
  // Save nav state to cache
  set: (consoleType, navState) => {
    try {
      const cacheKey = `${NAV_STATE_CACHE_KEY_PREFIX}${consoleType}`;
      const cacheData = {
        data: navState,
        timestamp: Date.now()
      };
      localStorage.setItem(cacheKey, JSON.stringify(cacheData));
    } catch (error) {
      console.error('Error saving nav state to cache:', error);
    }
  },

  // Get nav state from cache
  get: (consoleType) => {
    try {
      const cacheKey = `${NAV_STATE_CACHE_KEY_PREFIX}${consoleType}`;
      const cached = localStorage.getItem(cacheKey);
      
      if (!cached) return null;
      
      const cacheData = JSON.parse(cached);
      const now = Date.now();
      
      // Check if cache is expired
      if (now - cacheData.timestamp > NAV_STATE_CACHE_EXPIRY) {
        // Cache expired, remove it
        localStorage.removeItem(cacheKey);
        return null;
      }
      
      return cacheData.data;
    } catch (error) {
      console.error('Error reading nav state from cache:', error);
      return null;
    }
  },

  // Clear nav state cache for specific console
  clear: (consoleType) => {
    try {
      const cacheKey = `${NAV_STATE_CACHE_KEY_PREFIX}${consoleType}`;
      localStorage.removeItem(cacheKey);
    } catch (error) {
      console.error('Error clearing nav state cache:', error);
    }
  },

  // Clear all nav state caches
  clearAll: () => {
    try {
      ['admin-console', 'iam-console'].forEach(consoleType => {
        NavStateCache.clear(consoleType);
      });
    } catch (error) {
      console.error('Error clearing all nav state caches:', error);
    }
  }
};